export const addCurrentToGroups = (
  currentGroups: User.Group[] | undefined = [],
  currentGroup: User.Group
): User.Group[] =>
  currentGroups.map((group) =>
    group._id === currentGroup._id ? currentGroup : group
  );
